<!--互联互通-->
<template>
    <v-main>
        <top-bar
            :height="'48vh'"
            title="互联互通"
            addTitle="添加"
            :loading="loading"
            :u_loading="u_loading"
            :isShowRefresh="true"
            @refresh="refresh"
            @add="add"
            @updatePrice="updatePrice"
            @search="search"
        />
        <v-container fluid class="mt-n6">
            <v-row>
                <v-col cols="12" md="12">
                    <v-data-table
                        :headers="headers"
                        :items="dataTable"
                        :items-per-page="10"
                        disable-sort
                        :loading="loading"
                        loading-text="数据加载中..."
                        no-data-text="暂无数据"
                        :server-items-length="totalCount"
                        :options.sync="options"
                        :footer-props="footerProps"
                        :dark="theme.tableDark"
                    >
                        <template v-slot:item.name="{ item }">
                            <el-tooltip
                                class="item"
                                effect="dark"
                                :content="item.name"
                                placement="top"
                            >
                                <div class="textOver" style="width: 10rem">
                                    <el-link
                                        type="primary"
                                        icon="el-icon-view el-icon--right"
                                        class="ml-3"
                                        @click="showDetails(item)"
                                    >
                                        {{ item.name }}
                                    </el-link>
                                </div>
                            </el-tooltip>
                        </template>
                        <template v-slot:item.editor="{ item }">
                            <el-button type="primary" size="medium" @click="pullSite(item)">
                                拉取站点
                            </el-button>
                            <el-popconfirm
                                confirm-button-text="确定"
                                cancel-button-text="取消"
                                icon="el-icon-info"
                                icon-color="red"
                                title="确定要删除此项吗"
                                @confirm="confirm(item.id)"
                            >
                                <el-button type="text" slot="reference" class="pl-10">
                                    <v-icon class="ml-3" color="red">
                                        mdi-delete
                                    </v-icon>
                                </el-button>
                            </el-popconfirm>
                        </template>
                        <template v-slot:item.station_ids="{ item }">
                            <!-- <el-link
                                type="primary"
                                v-for="(id, index) in item.station_ids"
                                :key="index"
                                @click="showSite(id)"
                                v-if="index <= 1"
                                icon="el-icon-view el-icon--right"
                                style="font-size:1vw"
                            >
                                {{ showStationName(id) }}
                            </el-link>
                            <el-link
                                type="primary"
                                v-if="item.station_ids.length"
                                style="font-size:1vw"
                                class="ml-5"
                                @click="showMore()"
                            >
                                更多
                            </el-link> -->
                            <div class="more">
                                <el-link
                                    type="primary"
                                    v-for="(id, index) in item.station_ids"
                                    :key="index"
                                    @click="showSite(id)"
                                    icon="el-icon-view el-icon--right"
                                    style="font-size:1vw"
                                >
                                    {{ showStationName(id) }}
                                </el-link>
                            </div>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog
            scrollable
            v-model="isAdd"
            :persistent="persistent"
            width="60em"
            overlay-color="#262626"
        >
            <contact-form
                v-if="isSite"
                :isAddSite="isAddSite"
                :contactData="contactData"
                @cancel="cancel"
                @refresh="refresh"
            />
        </v-dialog>
        <v-dialog
            scrollable
            v-model="isEdit"
            :persistent="persistent"
            width="60em"
            overlay-color="#262626"
        >
            <site-form
                @noEditor="noEditor"
                :editSite="editSite"
                @refresh="refresh"
                v-if="isEditSite"
            />
        </v-dialog>
    </v-main>
</template>
<script>
import util from "@/util";
import ContactForm from "@/components/Form/ContactForm";
import SiteForm from "@/components/Form/SiteForm";
import TopBar from "@/components/TopBar";
import store from "@/store";
import { mapState } from "vuex";
export default {
    name: "Contact",
    data() {
        return {
            activeNames: [],
            loading: false,
            persistent: true,
            isAdd: false, //是否打开弹出框
            isAddSite: false, //是否是添加
            isSite: true,
            u_loading: false, //更新价格动画
            headers: [
                { text: "公司名称", value: "name" },
                { text: "对接运营商ID", value: "operator_id" },
                { text: "本公司运营商ID", value: "my_operator_id" },
                { text: "站点", value: "station_ids" },
                { text: "", value: "editor" },
            ],
            totalCount: 1000,
            footerProps: {
                itemsPerPageText: "每页显示数目",
                itemsPerPageOptions: [5, 10, 15],
                showCurrentPage: true,
                showFirstLastPage: true,
            },
            options: {}, //外部控制分页
            dataTable: [], //数据表数据
            contactData: {},
            allSite: [
                { value: "站点1", id: 4 },
                { value: "站点2", id: 5 },
                { value: "站点3", id: 0 },
                { value: "站点4", id: 1 },
                { value: "站点5", id: 2 },
                { value: "站点6", id: 3 },
            ],
            no_data: false,
            isEdit: false, //是否打开编辑弹出框
            isEditSite: true,
            editSite: {}, //向编辑站点组件传递的数据
        };
    },
    watch: {
        // 刷新参数
        options: {
            handler() {
                this.refresh();
            },
            deep: true,
        },
        contactData() {
            this.isSite = false;
            this.$nextTick(() => {
                this.isSite = true;
            });
        },
        editSite() {
            this.isEditSite = false;
            this.$nextTick(() => {
                this.isEditSite = true;
            });
        },
    },
    components: {
        ContactForm,
        SiteForm,
        TopBar,
    },
    computed: {
        ...mapState(["contactInfo", "stationDetail", "siteInfo", "topBarBgColor", "theme"]),
    },
    methods: {
        showMore() {},
        /*搜索*/
        async search(reg) {
            this.loading = true;
            let postData = {};
            await store.dispatch("getConnact", postData);
            let dataArr = [];
            for (let i = 0; i < this.contactInfo.length; i++) {
                if (
                    reg.test(this.contactInfo[i].name) ||
                    reg.test(this.contactInfo[i].id) ||
                    reg.test(this.contactInfo[i].operator_id) ||
                    reg.test(this.contactInfo[i].my_operator_id)
                ) {
                    dataArr.push(this.contactInfo[i]);
                }
            }
            this.dataTable = dataArr.reverse();
            this.loading = false;
            if (dataArr.length == 0) {
                util.ShowTip("未查找到相关数据", 2);
                await this.refresh();
                return;
            }
            util.ShowTip("查询到" + dataArr.length + "条数据", 1);
        },
        async refresh() {
            this.loading = true;
            await store.dispatch("getConnact", {});
            this.dataTable = this.contactInfo;
            for (let i = 0; i < this.dataTable.length; i++) {
                this.dataTable[i].p_loading = false;
            }
            let postData = {
                from: 0,
                limit: 10000,
            };
            await store.dispatch("getSite", postData);
            this.loading = false;
        },
        /*添加*/
        add() {
            this.isAdd = true;
            this.isAddSite = true;
            this.persistent = true;
        },
        /*拉取站点*/
        pullSite(item) {
            const h = this.$createElement;
            this.$confirm("是否拉取  " + item.name + "  的站点", "提示", {
                title: "提示",
                message: h("p", null, [
                    h("span", null, "是否拉取  "),
                    h("i", { style: "color: red" }, item.name),
                    h("span", null, " 的站点"),
                ]),
                showCancelButton: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true,
                // roundButton: true,
            })
                .then(() => {
                    this.pullFun(item.id);
                })
                .catch(() => {});
        },
        async pullFun(id) {
            const loading = this.$loading({
                lock: true,
                text: "拉取中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            let params = {
                data: { id: id },
                callback: () => {
                    loading.close();
                },
            };
            await store.dispatch("fetchStation", params);
        },
        /*取消添加*/
        cancel() {
            this.contactData = {};
            this.isAdd = false;
        },
        /*删除*/
        confirm(id) {
            console.log(id);
        },
        /*显示站点详细信息*/
        async showSite(id) {
            await store.dispatch("getSite", { from: 0, limit: 10000 });
            let station_id = id;
            for (let i = 0; i < this.siteInfo.length; i++) {
                if (this.siteInfo.some(({ id }) => id == station_id)) {
                    if (id === this.siteInfo[i].id) {
                        this.editSite = this.siteInfo[i];
                        this.isEdit = true;
                    }
                } else {
                    util.ShowTip("该站点信息不存在", 0);
                }
            }
        },
        /*取消站点编辑*/
        noEditor() {
            this.isEdit = false;
        },
        /*打开互联互通详细信息*/
        showDetails(item) {
            this.isAdd = true;
            this.isAddSite = false;
            this.persistent = false;
            this.contactData = item;
        },
        /*更新价格*/
        async updatePrice() {
            let that = this;
            that.u_loading = true;
            that.$confirm("是否更新价格", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    that.updatePriceFun();
                })
                .catch(() => {});

            that.u_loading = false;
        },
        async updatePriceFun() {
            await store.dispatch("updatePrice", {});
        },
        /*显示站点名称*/
        showStationName(station_id) {
            let idArr = [];
            let text = null;
            for (let i = 0; i < this.siteInfo.length; i++) {
                if (station_id == this.siteInfo[i].id) {
                    text = this.siteInfo[i].name;
                }
                idArr.push(this.siteInfo[i].id);
            }
            if (!idArr.includes(station_id)) {
                text = station_id;
            }
            return text;
        },
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.refresh();
        });
    },
};
</script>
<style scoped>
.textOver {
    width: 9em;
    font-size: 1em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}
.more {
    max-width: 25rem;
    height: 3.5em;
    /* background-color: red; */
    overflow-x: hidden;
    overflow-y: auto;
}
</style>
